import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-admin-portal',
  templateUrl: './admin-portal.component.html',
  styleUrls: ['./admin-portal.component.scss']
})
export class AdminPortalComponent implements OnInit {

  constructor(private route: Router) { }

  ngOnInit() {
  }

  goToURL(route) {
    if (route) {
      this.route.navigateByUrl('admin/' + route);
    } else {
      this.route.navigateByUrl('admin');
    }
  }
}
